module.exports = __webpack_public_path__ + "static/board-27-87c7e5b465c4d29d5bc33e1514030327.jpg";